// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__os-0Y","title":"ClientReferral_title__3RWZd","itemText":"ClientReferral_itemText__MkK9o"};